var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"comp-icon",attrs:{"width":_vm.width,"height":_vm.height || _vm.width,"src":_vm.productLogo,"alt":"","onerror":_vm.errorImg}})
}
var staticRenderFns = []

export { render, staticRenderFns }